import * as React from 'react';
import { Alert } from '@lightspeed/flame/Alert';
import { Button } from '@lightspeed/flame/Button';
// @ts-expect-error ts-migrate(6133) FIXME: 'Text' is declared but its value is never read.
import { Text } from '@lightspeed/flame/Text';
import { Flex, Box } from '@lightspeed/flame/Core';

import Localize from 'app/src/localize/Localize';
import RetailManager from 'app/retail_manager/RetailManager';
import { CashInputForm } from './CashInputForm';
import { CreditInputForm } from './CreditInputForm';
import { usePaymentContext } from '../Store/PaymentState';
import { UserDefinedPaymentTypeForm } from '../components/UserDefinedPaymentTypeForm';
import { ApprovedPaymentsList } from './ApprovedPaymentsList';

export const CardPaymentButton = ({ goToCardView }: TSFixMe) => {
  const { paymentProvider } = usePaymentContext();
  const [isVisible, setIsVisible] = React.useState(false);
  const [isDisabled, setIsDisabled] = React.useState(false);

  /**
   *  Adapted from disableCreditDebitButton in PaymentDefaultViewController.
   */
  React.useEffect(() => {
    const isCardBtnDisabled = (() => {
      const supportsTerminal =
        paymentProvider.activeGatewayHasConfiguredTerminals() ||
        paymentProvider.activeGatewaySupportsUSBSwipe() ||
        paymentProvider.activeGatewaySupportsManualEntry;

      if (RetailManager.active || paymentProvider.activeGatewaySupportsManualEntryFromTerminal) {
        return false;
      }

      return !supportsTerminal;
    })();

    setIsDisabled(isCardBtnDisabled);
    setIsVisible(paymentProvider.activeGateway !== null);
  }, [paymentProvider, setIsDisabled]);

  return (
    <>
      {isVisible && (
        <Flex justifyContent="center" flexWrap="wrap" mb={3}>
          <Button
            fill
            disabled={isDisabled}
            onClick={goToCardView}
            id="credit_card_button"
            aria-label="Credit Debit Button"
          >
            Credit/Debit
          </Button>
        </Flex>
      )}
    </>
  );
};

const UserDefinedPaymentTypesForm = () => {
  const { userDefinedPaymentTypes } = usePaymentContext();

  /* TODO: add customer required for custom method */
  return (
    <>
      {userDefinedPaymentTypes.map(({ name, paymentTypeID }: TSFixMe) => (
        <Box key={paymentTypeID} pt={2}>
          <UserDefinedPaymentTypeForm name={name} paymentTypeID={paymentTypeID} />
        </Box>
      ))}
    </>
  );
};

export const PaymentDefaultView: React.FC = () => {
  const { canRetrieveGateway } = usePaymentContext();

  return (
    <>
      {!canRetrieveGateway && (
        <Alert type="warning" aria-label="gateway error warning" noCloseBtn mb={2}>
          <>
            {Localize.translate(
              'Some actions are temporarily unavailable due to service degradation.'
            )}
          </>
        </Alert>
      )}
      <CreditInputForm />
      <CashInputForm />
      <UserDefinedPaymentTypesForm />
      <ApprovedPaymentsList />
    </>
  );
};
